<template>
  <HeroView/>
  <ThemesView/>
  <PerfectView/>
  <BenefitsView/>
  <FaqView/>
  <FinalView/>
</template>

<script>
import HeroView from '@/components/home/HeroView.vue'
import ThemesView from '@/components/home/ThemesView.vue'
import PerfectView from '@/components/home/PerfectView.vue'
import BenefitsView from '@/components/home/BenefitsView.vue'
import FaqView from '@/components/home/FaqView.vue'
import FinalView from '@/components/home/FinalView.vue'

export default {
  name: 'HomeView',
  components: {
    HeroView,
    ThemesView,
    PerfectView,
    BenefitsView,
    FaqView,
    FinalView
  }
}
</script>

<script setup>
import { useHead } from '@vueuse/head'

useHead({
  title: 'Almost Perfect Studio – Advanced & Bold Shopify Themes',
  meta: [
    { name: 'description', content: 'Discover high-performing Shopify themes built for conversions. Explore our theme portfolio and launch a faster, smarter, more profitable store.' },

    { property: 'og:title', content: 'Almost Perfect Studio – Advanced Shopify Themes' },
    { property: 'og:description', content: 'Launch a high-performing Shopify store with bold, advanced themes built for growth and speed.' },
    { property: 'og:image', content: '/assets/imgs/og_image.png' },
    { property: 'og:url', content: 'https://almostperfectstudio.com/' },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:site_name', content: 'Almost Perfect Studio' }
  ]
})
</script>
